<div class="container-form">
  <div *ngIf="randomizedDocumentUploadMode === 0" class="container-form__banner"></div>
  <div class="form">
    <div class="div-input">

      <div class="d-flex align-items-center mb-3">
        <mat-checkbox
          [(ngModel)]="hasIne"
          (change)="filterByIneDomicile()"
        >
          Tengo INE
        </mat-checkbox>

        <mat-checkbox
          *ngIf="hasIne"
          [(ngModel)]="ineDomicileComplete"
          (change)="filterByIneDomicile()"
        >
          Mi INE tiene domicilio completo
        </mat-checkbox>
      </div>

      <ng-container *ngFor="let docSection of filteredSections">
        <div class="container-text-title">
          <p class="text-label">{{ docSection.name }}</p>
          <button mat-icon-button matTooltip="Modelo del documento" (click)="openViewModelDocuments(docSection)">
            <img src="../../../assets/images/icon-info.png" />
          </button>
        </div>

        <mat-card appearance="outlined" class="style-card" *ngFor="let op of docSection.documents">
          <mat-card-content class="style-card-text">
            {{ op.inputName }}
            <ng-container *ngIf="op.data?.spinner; else publish">
              <mat-spinner [diameter]="22"></mat-spinner>
            </ng-container>

            <ng-template #publish>
              <ng-container *ngIf="op.scanned || op.uploaded || internalScannedDocuments.includes(op.id); else upload">
                <div class="icons-upload">
                  <button mat-icon-button matTooltip="Ver documento" color="primary" (click)="viewDocuments(op.fileName! || op.data?.fileName!)">
                    <mat-icon>remove_red_eye</mat-icon>
                  </button>
                  <button *ngIf="docSection.name === 'Comprobante de domicilio'" mat-icon-button matTooltip="Eliminar documento" color="primary" (click)="confirmDeleteDocuments(op.fileName!, op.data!)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </ng-container>
              <ng-template #upload>
                <div class="icons-upload">
                  <!-- Camera -->
                  <ng-container *ngIf="docSection.name === 'INE' && cameraMovil && randomizedDocumentUploadMode === 0">
                    <label (click)="openCamera(op)" mat-icon-button matTooltip="Tomar fotografía" for="{{ op.data?.id }}-'camera'" style="margin-right: 5px">
                      <span class="dot">
                        <mat-icon class="icon-upload">camera_alt</mat-icon>
                      </span>
                    </label>
                  </ng-container>
                  <ng-container *ngIf="docSection.name === 'INE' && cameraMovil && randomizedDocumentUploadMode === 1">
                    <label mat-icon-button matTooltip="Tomar fotografía" for="{{ op.data?.id }}-'camera'" style="margin-right: 5px">
                      <span class="dot">
                        <mat-icon class="icon-upload">camera_alt</mat-icon>
                      </span>
                    </label>
                    <input type="file" accept="image/*" capture="enviroment" id="{{ op.data?.id }}-'camera'" (change)="loadDocument($event, op.data!, 'NATIVE_CAMERA', op.id)" style="display: none"/>
                  </ng-container>
                  <!-- Document -->
                  <label class="mat-icon-button" matTooltip="Subir documento">
                  <input
                    type="file"
                    accept="image/png, image/jpeg, application/pdf, .rar"
                    (change)="loadDocument($event, op.data!, 'NORMAL', op.id)"
                    hidden
                  />
                  <span class="dot">
                    <mat-icon class="icon-upload">file_upload</mat-icon>
                  </span>
                </label>
                </div>
              </ng-template>
            </ng-template>
          </mat-card-content>
        </mat-card>
      </ng-container>
      <div *ngIf="hasIne && !ineDomicileComplete" class="domicile-wrapper">
        <div class="container-text-title">
          <p class="text-label">Domicilio</p>
        </div>
        <mat-form-field style="width: 100%;" appearance="fill">
          <mat-label>Calle</mat-label>
          <input
            autocomplete="off"
            matInput
            placeholder="Calle"
            [(ngModel)]="domicileInputValue"
          />
        </mat-form-field>
        <div class="inputs-wrapper">
          <mat-form-field class="inputs-wrapper__left" appearance="fill">
            <mat-label>Num ext./Mz</mat-label>
            <input
              autocomplete="off"
              matInput
              placeholder="Num ext./MZ"
              [(ngModel)]="domicileNumberInputValue"
            />
          </mat-form-field>
          <mat-form-field *ngIf="hasIne && !ineDomicileComplete" appearance="fill">
            <mat-label>Num int./Lt</mat-label>
            <input
              autocomplete="off"
              matInput
              placeholder="Num int./Lt"
              [(ngModel)]="domicileInternalNumberInputValue"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="div-button-form">
  <div class="boton-siguiente-lto-container">
    <button class="boton-siguiente-lto" mat-raised-button [disabled]="isWaitingApi || (hasIne && !ineDomicileComplete && domicileInputValue.length === 0)" (click)="buttonSendDocument()">
      ENVIAR DOCUMENTACIÓN
    </button>

    <mat-spinner
      class="save-spinner"
      diameter="26"
      *ngIf="isWaitingApi"
    ></mat-spinner>
  </div>
</div>

<app-camera [currentDocumentTypeId]="selectedDocument?.id || 0" (confirmPhotoEmitter)="confirmPhoto($event)"></app-camera>
